/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
export class GridColumnPositionController {
    constructor(host) {
        this.host = host;
        this.previousPosition = '';
        this.host.addController(this);
    }
    get hostGrid() {
        return this.host.parentElement;
    }
    async hostUpdated() {
        await this.host.updateComplete;
        if (this.host.ariaColIndex && this.host.position !== this.previousPosition) {
            this.previousPosition = this.host.position;
            if (!this.styles) {
                this.styles = document.createElement('style');
                this.hostGrid.append(this.styles);
            }
            this.calculateColumnPositionStyles();
        }
    }
    calculateColumnPositionStyles() {
        const gridPosition = this.hostGrid.getBoundingClientRect();
        const side = this.host.offsetLeft < gridPosition.width / 2 ? 'left' : 'right';
        this.styles.innerHTML = `${this.getPositionStyle(side, gridPosition)}\n${this.borderStyle(side)}`;
    }
    getPositionStyle(side, gridPosition) {
        const position = this.host.getBoundingClientRect();
        const left = this.host.position === 'fixed' ? `${position.left - gridPosition.left - 1}px` : 'initial';
        const right = this.host.position === 'fixed' ? `${position.right - position.left - position.width}px` : 'initial';
        return `
    [__id='${this.hostGrid._id}'] [aria-colindex="${this.host.ariaColIndex}"] {
      ${side === 'left' ? `left: ${left};` : ''}
      ${side === 'right' ? `right: ${right};` : ''}
      ${this.host.position === 'sticky' ? `left: 0px;` : ''}
    }

    [__id='${this.hostGrid._id}'] cds-grid-cell[aria-colindex="${this.host.ariaColIndex}"] {
      z-index: 98;
    }`;
    }
    borderStyle(side) {
        const lastofLeft = side === 'left' && this.host.nextElementSibling.position !== this.host.position;
        const lastofRight = side === 'right' && this.host.previousElementSibling.position !== this.host.position;
        if (this.host.position !== '' && (lastofLeft || lastofRight)) {
            // todo: test last of position
            return `
      [__id='${this.hostGrid._id}'] cds-grid-cell[aria-colindex="${this.host.ariaColIndex}"] {
        --border-${side === 'left' ? 'right' : 'left'}: var(--cds-alias-object-border-width-100) solid var(--cds-alias-object-border-color);
      }`;
        }
        else {
            return '';
        }
    }
}
